import React, { Component } from 'react';
import classes from './TwitterIcon.module.scss';
import { getFileName } from 'helpers/FileCaching';
import globalJSON from 'data/global.json'
// const socialIcons = require.context('images/components/Global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);
const socialIcons = require.context('images/components/Articles/Article/SocialIcons', true, /.*\.(gif|png|jpe?g|svg)$/i);

class TwitterIcon extends Component {

    constructor(props){

        super(props);

        this.state = {
            imgSrc: getFileName(socialIcons, 'twitter-1.svg'),
            showPopup: false
        };

        //  this.handleMouseOver = this.handleMouseOver.bind(this);
        //  this.handleMouseOut = this.handleMouseOut.bind(this);
         
         this.twitterVia = ""
         this.hashtags = ""

         if(props.twitterDescriptionVia !== undefined){
          this.twitterVia = "&via="+props.twitterDescriptionVia;
         }

         if(props.twitterDescriptionHashtag !== undefined){
          this.hashtags = "&hashtags="+props.twitterDescriptionHashtag;
         }
    }

    // handleMouseOver() {
    //     this.setState({
    //       imgSrc: getFileName(socialIcons, 'twitter-icon-hover.svg')
    //     });
    //   }
    
    //   handleMouseOut() {
    //     this.setState({
    //       imgSrc: getFileName(socialIcons, 'twitter-1.svg')
    //     });
    //   }

      showModal = () => {
        this.setState({ show: true });
      };
    
      hideModal = () => {
        this.setState({ show: false });
      };

      popUp = (e) => {
        e.preventDefault();
        let type = e.currentTarget.getAttribute('data-social');
        console.log(type);
        let link = e.currentTarget.getAttribute('href');
        
        if(type == "twitter"){
            link = encodeURI(link);
        }
        console.log(link);
        popupCenter(link,'xtf','500','500');
      }
      
      onClick(event){

        window.gtag('event', "clicked to share on twitter", {
          'event_category': globalJSON.tracking.ga_category,
      	'event_label': "clicked to share article "+ event.currentTarget.attributes['data-url'].value + " on twitter",
      	'value':10
        });
      
      console.log(event.currentTarget.attributes['data-url'].value)
      }

    render(){
      let style ={
        // WebkitTransition: 'all 0.1s ease-in', // note the capital 'W' here
        // msTransition: 'all 0.1s ease-in' // 'ms' is the only lowercase vendor prefix
        }

        let animationTiming ={
            enter: 400,
            exit:1000
        }
        return (
            <li className={`socialIcons__item`}>
             <div className={`socialIcons__wrapper`}>
                <a className={classes.socialIcons__link} onClick={this.popUp}  onClick={this.onClick} data-social="twitter" target="_blank" rel="noopener" href={`https://twitter.com/intent/tweet?text=${this.props.twitterDescription}${this.hashtags}${this.twitterVia}&url=${this.props.url}`} data-url={this.props.url}>
                    <img className={`twitterIconHover ${classes.socialIcons__imgHover}`} src={getFileName(socialIcons, 'twitter-icon-hover.svg')} alt="share"/>
                    <img className={`twitterIcon ${classes.socialIcons__img}`} src={this.state.imgSrc} alt="share"/>
                </a>
                </div>
            </li>
        );
    }
}



const popupCenter = (url, title, w, h) => {

  const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : this.screen.left;
  const dualScreenTop = window.screenTop != undefined ? window.screenTop : this.screen.top;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : this.screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : this.screen.height;

  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;
  const newWindow = window.open(url, title, 'status=yes,toolbar=no,menubar=no,location=no,width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
  
  if (window.focus) {
      newWindow.focus();
  }

}

export default TwitterIcon;

  
  